export const KEY_MAP = {
  ACCESS_TOKEN: "access_token",
  EXPIRES_AT: "expires_at",
  USER_ID: "user_id",
  HAS_SEEN_CONTRIBUTOR_QUESTS_INTRO: "has_seen_contributor_quests_intro",
  STRIPE_CHECKOUT_DATA: "stripe_checkout_data",
  DISCORD_AUTH_REDIRECT_URL: "discord_auth_redirect_url",
  ONBOARDING_INTERESTS: "onboarding_interests",
  SHOULD_WHITELIST_USER: "should_whitelist_user",
  ORG_QUESTS_PATH_AND_ISSUE_URL: "org_quests_path_and_issue_url",
  IS_ORG_ADMIN_SIGN_UP: "is_org_admin_sign_up",
  QUEST_INVITATION_PAGE_STATE: "quest_invitation_page_state",
  EMAIL_VERIFICATION_SENT: "email_verification_sent",
};
